<script>
export default {
  name: "IconWhiteCross"
};
</script>

<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M10.185.311a1.063 1.063 0 011.592 1.404l-.088.1-9.874 9.874a1.063 1.063 0 01-1.592-1.404l.088-.1L10.185.31z"
      />
      <path
        d="M1.815.311A1.063 1.063 0 00.223 1.715l.088.1 9.874 9.874a1.063 1.063 0 001.592-1.404l-.088-.1L1.815.31z"
      />
    </g>
  </svg>
</template>
